<template>
  <div
    class="data-label"
    :class="{
      'data-label--highlight': highlight,
      'data-label--warning': warning
    }"
  >
    <slot />
  </div>
</template>

<script>
  export default {
    name: 'DataLabel',
    props: {
      highlight: {
        type: Boolean,
        default: false
      },
      warning: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style lang="scss">
  .data-label {
    color: rgba(0, 0, 0, .54);
    font-size: 16px;
    font-weight: 400;

    &--highlight {
      font-weight: 500;
      color: #212121;
    }

    &--warning {
      color: #ff0000;
    }
  }
</style>
